import { listStyles as styles } from "@waytek/Overrides/Widgets/Brand/BrandList";
import { css } from "styled-components";

styles.queryContainer = {
    gap: 10,
    css: css`
        align-items: center;
    `,
};

styles.alphabetNavItem = {
    width: [12, 12, 12, 8, 8],
};

styles.searchNavItem = {
    width: [12, 12, 12, 4, 4],
};

styles.brandAlphabetNavigation = {
    alphabetNavigation: {
        ...styles.brandAlphabetNavigation?.alphabetNavigation,
        container: {
            ...styles.brandAlphabetNavigation?.alphabetNavigation?.container,
            css: css`
                text-transform: uppercase;
                justify-items: center;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                min-width: 100%;
                width: 100%;
                height: 100%;
            `,
        },
        navigationItem: {
            ...styles.brandAlphabetNavigation?.alphabetNavigation?.navigationItem,
            css: css`
                margin: 0;
                display: inline-flex;
                flex: 0 0 20px;
                justify-content: center;
            `,
        },
    },
};
